import get from 'lodash/get';
import splitKeyValues from 'src/common/utils/split-prismic-key-vals';
import { skus } from 'src/common/config/product';
import logger from 'src/logger';

export const getPageNumber = (props = {}, item = {}) => {
  if (item.pageNumber) {
    return item.pageNumber;
  }

  if (!item.extraChoices) {
    logger.error(`Breadcrumb ${item.label}: missing page number or extra choice`);
    return null;
  }

  const { key: property, value: customisation } = splitKeyValues(
    item.extraChoices,
  );

  if (!props.productCustomisation[property]) {
    return null;
  }

  const breadcrumbMarkers =
    get(props, 'globalContent.canvas.body', []).find(
      slice => slice.sliceType === 'breadcrumb_markers',
    ) || {};

  const allMarkers = breadcrumbMarkers.items || [];
  const productMarkers = allMarkers.filter(marker => {
    const { key, value } = splitKeyValues(marker.pageId);
    return key === skus[props.productKey] && value.split('-')[0] === property;
  });

  const index = props.productCustomisation[property].indexOf(customisation) + 1;
  const pageMarker = productMarkers.find(marker =>
    marker.pageId.match([property, index].join('-')),
  );

  if (!pageMarker) {
    return null;
  }

  return pageMarker.pageNumber;
};



// WEBPACK FOOTER //
// ./src/client/js/view/components/BreadCrumb/helpers.js